<template>
	<div class="menu-toggle">

		<f-button @click="handleClick" :type="'image'">
			<img v-if='menuOpen' src="@/assets/img/close.png"/>
			<img v-else src="@/assets/img/hamburger.png"/>
		</f-button>

	</div>
</template>


<!-- Script
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
<script>
export default {
	name: 'MenuToggle',
	props: ['menuOpen'],
	data() {
		return {
		}
	},
	methods: {
		handleClick: function() {
			this.$emit('click')
		}
	}
}
</script>

<!-- Style
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
<style lang="scss">

</style>
